app.service('simpleToastr', function (broker, localStorage) {
	var $self, $el;
	var timeout = 5000;

	function checkMessage(){
		if (localStorage.getItem('afterReloadMessage')) {
			generate(localStorage.getItem('afterReloadMessage'));
			localStorage.removeItem('afterReloadMessage');
		}
	}
	function init() {
		broker.on('RELOAD_CART_SUCCESS', function () {
			checkMessage();
		});
		checkMessage();
	}
	function afterReloadMessage(message) {
		localStorage.setItem('afterReloadMessage', message);
	}
	function generate(content, params) {
		function close() {
			$box.addClass('hide');
		}
		if(!$self || !$self.length){
			$self = $('<div id="simple-toastr-box"/>').appendTo('body');
			$el = document.querySelector('#simple-toastr-box');
		}
		if(params && params.closeOthers){
			$self.find('.toastr').addClass('hide');
		}
		var $box = $(`<div class="toastr">${content}</div>`).appendTo($self);
		$box.addClass(params && params.modifier ? 'modifier-'+params.modifier : 'modifier-default');
		$(`<div class="toastr-close">
			<svg width="32" height="32" viewBox="0 0 32 32" fill="none" class="close-progress">
				<path d="M11 21L21 11M11 11L21 21" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
				<circle cx="16" cy="16" r="14" />
			</svg>
			</div>`).appendTo($box).click(close);
		setTimeout(close, timeout);
		$el.style.setProperty('--close-duration', timeout+'ms');
	}

	return {
		init,
		afterReloadMessage,
		generate
	};
});
